import { useState } from 'react';
import { useMarketingData } from '../MarketingContext';

export default function BlogsPage() {
  const { blogs, toggleBlogSaved } = useMarketingData();
  const [search, setSearch] = useState('');
  const [showSaved, setShowSaved] = useState(false);

  const filtered = blogs.filter(b => {
    if (search && !b.title.toLowerCase().includes(search.toLowerCase()) && !b.topic.toLowerCase().includes(search.toLowerCase())) return false;
    if (showSaved && !b.saved) return false;
    return true;
  });

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-gray-900">Blogs & Articles</h1><p className="text-sm text-gray-500">Curated industry articles and research digest</p></div>
      <div className="flex gap-3 bg-white p-3 rounded-xl border border-gray-200">
        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search articles..." className="flex-1 px-3 py-1.5 text-sm border border-gray-200 rounded-lg" />
        <button onClick={() => setShowSaved(!showSaved)} className={`px-3 py-1.5 text-xs font-medium rounded-lg ${showSaved ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-600'}`}>{showSaved ? '★ Saved' : '☆ Saved'}</button>
      </div>
      <div className="space-y-3">
        {filtered.map(b => (
          <div key={b.id} className="bg-white border border-gray-200 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="text-sm font-bold text-gray-900">{b.title}</div>
                <div className="text-xs text-gray-500 mt-0.5">{b.author} · {b.publisher} · {b.publishDate}</div>
                <div className="flex gap-2 mt-1.5 text-xs text-gray-400">
                  <span>{b.industry}</span><span>·</span><span>{b.topic}</span><span>·</span><span>Reliability: {b.reliability}/10</span>
                </div>
                <p className="text-xs text-gray-600 mt-2">{b.summary}</p>
                <div className="mt-2"><div className="text-xs font-medium text-gray-700">Key Lessons:</div><p className="text-xs text-gray-600">{b.keyLessons}</p></div>
                <div className="mt-1"><div className="text-xs font-medium text-gray-700">Recommended Actions:</div><p className="text-xs text-gray-600">{b.actions}</p></div>
                <div className="flex flex-wrap gap-1 mt-2">{b.tags.map(t => <span key={t} className="text-[10px] px-1.5 py-0.5 bg-gray-100 text-gray-500 rounded">{t}</span>)}</div>
              </div>
              <button onClick={() => toggleBlogSaved(b.id)} className={`ml-3 text-lg ${b.saved ? 'text-amber-500' : 'text-gray-300 hover:text-amber-400'}`}>{b.saved ? '★' : '☆'}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
